import React from 'react';
import ContentLoader from 'react-content-loader';
import PropTypes from 'prop-types';

const QrCodePlaceholder = ({size = 84}) => (
    <>
        <ContentLoader
            className="qrcode"
            width={size}
            height={size}
            backgroundColor="#eee"
            foregroundColor="#ddd"
        >
            <rect width={size} height={size} rx="4" fill="#eee" />
        </ContentLoader>
    </>
);

QrCodePlaceholder.propTypes = {
    size: PropTypes.number,
};

export default QrCodePlaceholder;
